export class FiltersUtils {

  public static getFilter(filter: any): any {
    return filter || '';
  }

  public static getFilterTrim(filterString: string): string {
    return filterString ? filterString.trim() : '';
  }

  public static getFilterBoolean(filterBoolean: boolean): any {
    return filterBoolean ?? '';
  }

}
